"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeterminateProgressBar = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var Typography_1 = require("../../atoms/Typography/Typography");
var DeterminateProgressBar_style_1 = __importDefault(require("./DeterminateProgressBar.style"));
var DeterminateProgressBar = function (_a) {
    var currentNumberOfParts = _a.currentNumberOfParts, totalNumberOfParts = _a.totalNumberOfParts, className = _a.className, showPercentage = _a.showPercentage;
    var classes = (0, DeterminateProgressBar_style_1.default)();
    var value = Math.floor((Math.min(currentNumberOfParts, totalNumberOfParts) * 100) / totalNumberOfParts);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)(classes.root, className) }, { children: [(0, jsx_runtime_1.jsx)(core_1.LinearProgress, { className: classes.progress, variant: 'determinate', value: value, classes: { bar: classes.bar } }), showPercentage && (0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ className: classes.percentage, bold: true }, { children: "".concat(value, "%") }))] })));
};
exports.DeterminateProgressBar = DeterminateProgressBar;
